import { useMutation } from '@tanstack/react-query';
import { ADDRESS_QUERIES } from '../../infrastructure/address/utils/queries';

export const useAddressService = () => {
  const useNormalizeAddressMutation = () => {
    return useMutation(ADDRESS_QUERIES.normalizeAddress());
  };

  return {
    useNormalizeAddressMutation,
  };
};
